import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as widgets from '../../../widgets'

export const DOC = gql`
  ${widgets.gql.fragments.widgetRef.DOC}
  fragment FragmentMosaicUiSlideoutActionRendering on MosaicUiSlideoutActionRendering {
    widget {
      ...FragmentMosaicWidgetRef
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicUiSlideoutActionRenderingFragment,
  ents.core.mosaic.Action.Rendering<ents.core.mosaic.Action.Operation.UiSlideout>
>({
  operation: () => ents.core.mosaic.Action.Operation.UiSlideout,
  payload: {
    usingFullInput: graphql.transformers.OUT.validate(
      graphql.transformers.OUT.select<
        graphql.schema.FragmentMosaicUiSlideoutActionRenderingFragment,
        | ents.core.mosaic.Action.Payload<ents.core.mosaic.Action.Operation.UiSlideout>
        | undefined,
        'widget'
      >('widget', widgets.gql.fragments.widgetRef.TRANSFORMER),
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  },
})
